import Weedle from './Weedle';

export default Weedle;



/** WEBPACK FOOTER **
 ** ./source/013-weedle/index.js
 **/